(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal() {
    var els = document.querySelectorAll('.ab-cta .reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', reveal);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-founder"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal() {
    var els = document.querySelectorAll('.ab-founder .reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', reveal);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal() {
    var els = document.querySelectorAll('.ab-story .reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', reveal);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-values"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal() {
    var els = document.querySelectorAll('.ab-values .reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', reveal);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible-content-nona"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.faq').forEach(function (faq) {
      if (faq.dataset.bound === '1') return;
      faq.dataset.bound = '1';
      var single = faq.dataset.singleOpen === 'true';
      if (!single) return;
      var items = faq.querySelectorAll('details.faq__item');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!this.open) return;
          items.forEach(function (other) {
            if (other !== d && other.open) other.removeAttribute('open');
          });
        });
      });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loved-by-you"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var walls = document.querySelectorAll('.lby__wall');
    if (!walls.length) return;
    if (!('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('lby--offscreen', !e.isIntersecting);
      });
    }, { rootMargin: '200px 0px' });
    walls.forEach(function (w) { obs.observe(w); });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-nona"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal() {
    document.querySelectorAll('.tnona').forEach(function (sec) {
      var cards = sec.querySelectorAll('.tnona__card');
      if (!('IntersectionObserver' in window)) {
        cards.forEach(function (c) { c.classList.add('is-visible'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      cards.forEach(function (c) { io.observe(c); });
    });
  }
  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', reveal);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner-nona"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.vbn').forEach(function (vbn) {
      if (vbn.dataset.bound === '1') return;
      vbn.dataset.bound = '1';
      var video = vbn.querySelector('video.vbn__video');
      var sound = vbn.querySelector('[data-vbn-sound]');

      if (video && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        try { video.removeAttribute('autoplay'); video.pause(); } catch (e) {}
      }

      if (sound && video) {
        sound.addEventListener('click', function () {
          video.muted = !video.muted;
          var on = !video.muted;
          sound.classList.toggle('is-on', on);
          sound.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (on) { var pr = video.play(); if (pr && pr.catch) pr.catch(function () {}); }
        });
      }
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-nona"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal() {
    var sections = document.querySelectorAll('.why-nona');
    sections.forEach(function (sec) {
      var cards = sec.querySelectorAll('.wn-card');
      if (!('IntersectionObserver' in window)) {
        cards.forEach(function (c) { c.classList.add('is-visible'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      cards.forEach(function (c) { io.observe(c); });
    });
  }
  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', reveal);
})();

  } catch(e) { console.error(e); }
})();
})();
